import Icons from "../../assets/icon";
import {
  Dropdown,
  InputField,
  SearchbarCom,
  HoverButton,
  DashboardHeading,
  SidenavbarCom,
} from "../../components";
import Textarea from "../../components/textarea";
import Functions from "./index.function";
function CreateJob() {
  const {
    loadingToapi,
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    errors,
    jobDropdowns,
    isLoading,
    dropdowns,
    dropdownLoading,
    states,
    statesisLoading,
    cities,
    citiesisLoading,
    selectedOption,
    handleSelectOptions,
    handleDropdwonSelect,
    onSubmit,
    options,
    select,
  } = Functions();
  return (
    <div className="h-screen w-screen flex flex-col bg-[#000000]">
      {/* Navbar */}
      <SearchbarCom />
      <div className="grid sm:grid-cols-7 lg:grid-cols-6 xs:pt-10 sm:pt-16 sm:px-2 lg:px-2 xl:px-3">
        {/* Left Sidebar */}
        <div className="sm:col-span-2 lg:col-span-1 xs:z-50">
          <SidenavbarCom />
        </div>
        {/* Center Content (Scrollable) */}
        <div className=" sm:col-span-5 scroll-container h-[calc(100vh-4rem)]">
          <div className={` w-full xs:px-1 sm:pl-4 lg:pl-5 pt-2 pb-1 h-full`}>
            <form
              className="flex flex-col relative w-full bg-[#1A1A1A]  xs:px-2 sm:px-5 lg:px-10 rounded-lg h-full"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="py-5 sm:py-10">
                <DashboardHeading title={"Create Job"} />
              </div>
              <div className="flex-1 overflow-y-auto scroll-container">
                <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                  <div className="relative xs:w-full sm:w-1/2 lg:w-1/2">
                    <InputField
                      control={control}
                      label="Job Title"
                      type="text"
                      name="jobtitle"
                      {...register("jobtitle", {
                        required: "Job Title is required",
                      })}
                      errors={errors}
                      onChange={(value) => setValue("jobtitle", value)}
                      isMandatory={true}
                    />
                  </div>
                  <div className="relative xs:w-full sm:w-1/2 lg:w-1/2">
                    <Dropdown
                      control={control}
                      rightIcon={Icons.arrowIcon}
                      label={"Jobs Type"}
                      options={jobDropdowns?.job_type}
                      name={"job_type"}
                      selectedValue={select?.job_type}
                      handleSelect={(value) =>
                        handleDropdwonSelect("job_type", value)
                      }
                      valueName="job_type"
                      valueoption="job_type_id"
                      errors={errors}
                      isLoading={isLoading}
                      isMandatory={true}
                    />
                  </div>
                </div>
                <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <Dropdown
                      control={control}
                      label={"Country"}
                      options={dropdowns?.country}
                      valueName="country"
                      valueoption="country_id"
                      name={"countries"}
                      rightIcon={Icons.arrowIcon}
                      selectedValue={select.country}
                      handleSelect={(value) =>
                        handleDropdwonSelect("country", value)
                      }
                      errors={errors}
                      isLoading={dropdownLoading}
                      isMandatory={true}
                    />
                  </div>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <Dropdown
                      control={control}
                      label={"Province / State"}
                      options={states}
                      name={"states"}
                      valueName="state"
                      valueoption="state_id"
                      rightIcon={Icons.arrowIcon}
                      selectedValue={select.states}
                      handleSelect={(value) =>
                        handleDropdwonSelect("states", value)
                      }
                      errors={errors}
                      isLoading={statesisLoading}
                      isMandatory={true}
                    />
                  </div>
                </div>
                <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <Dropdown
                      control={control}
                      rightIcon={Icons.arrowIcon}
                      label={"City"}
                      options={cities}
                      selectedValue={select?.city}
                      handleSelect={(value) =>
                        handleDropdwonSelect("city", value)
                      }
                      valueName="city"
                      valueoption="city_id"
                      name={"city"}
                      errors={errors}
                      isLoading={citiesisLoading}
                      isMandatory={true}
                    />
                  </div>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <InputField
                      control={control}
                      label="Post Code"
                      type="text"
                      name="postCode"
                      {...register("postCode", {
                        required: "Post Code is required",
                      })}
                      errors={errors}
                      onChange={(value) => setValue("postCode", value)}
                      isMandatory={true}
                    />
                  </div>
                </div>
                <div className="w-full px-[2px]">
                  <div className="w-full lg:pt-5">
                    <Textarea
                      lable={"Description"}
                      name={"description"}
                      register={register}
                      setValue={setValue}
                      errors={errors}
                      isMandatory={true}
                    />
                  </div>
                  <div className="w-full lg:pt-5">
                    <Textarea
                      lable={"Benefits"}
                      name={"benefits"}
                      register={register}
                      setValue={setValue}
                      errors={errors}
                      isMandatory={true}
                    />
                  </div>
                </div>
                <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <Dropdown
                      control={control}
                      rightIcon={Icons.arrowIcon}
                      label={"Job Shift"}
                      options={jobDropdowns?.job_shift}
                      selectedValue={select?.job_shift}
                      handleSelect={(value) =>
                        handleDropdwonSelect("job_shift", value)
                      }
                      valueName="job_shift"
                      valueoption="job_shift_id"
                      name={"job_shift"}
                      errors={errors}
                      isLoading={isLoading}
                      isMandatory={true}
                    />
                  </div>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <Dropdown
                      control={control}
                      rightIcon={Icons.arrowIcon}
                      label={"Gender"}
                      options={dropdowns?.gender}
                      name={"gender"}
                      selectedValue={select.gender}
                      handleSelect={(value) =>
                        handleDropdwonSelect("gender", value)
                      }
                      valueName="gender"
                      valueoption="id"
                      isRequired={true}
                      isLoading={dropdownLoading}
                    />
                  </div>
                </div>
                <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <InputField
                      control={control}
                      label="Expiry Date"
                      type="date"
                      name="expirydate"
                      cardIcon={Icons.calendarIcon}
                      {...register("expirydate", {
                        required: "Expiry Date is required",
                      })}
                      errors={errors}
                      onChange={(value) => setValue("expirydate", value)}
                      isMandatory={true}
                    />
                  </div>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <Dropdown
                      control={control}
                      rightIcon={Icons.arrowIcon}
                      label={"Degree Level"}
                      options={jobDropdowns?.degree_level}
                      name={"degree_level"}
                      selectedValue={select?.degree_level}
                      handleSelect={(value) =>
                        handleDropdwonSelect("degree_level", value)
                      }
                      valueName="degree_level"
                      valueoption="degree_level_id"
                      errors={errors}
                      isLoading={isLoading}
                      isMandatory={true}
                    />
                  </div>
                </div>
                <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <Dropdown
                      control={control}
                      rightIcon={Icons.arrowIcon}
                      label={"Job Experience"}
                      options={jobDropdowns?.job_experience}
                      name={"job_experience"}
                      selectedValue={select?.job_experience}
                      handleSelect={(value) =>
                        handleDropdwonSelect("job_experience", value)
                      }
                      valueName="job_experience"
                      valueoption="job_experience_id"
                      errors={errors}
                      isLoading={isLoading}
                      isMandatory={true}
                    />
                  </div>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <Dropdown
                      control={control}
                      rightIcon={Icons.arrowIcon}
                      label={"Salary Period"}
                      options={jobDropdowns?.salary_period}
                      name={"salary_period"}
                      selectedValue={select?.salary_period}
                      handleSelect={(value) =>
                        handleDropdwonSelect("salary_period", value)
                      }
                      valueName="salary_period"
                      valueoption="salary_period_id"
                      errors={errors}
                      isLoading={isLoading}
                      isMandatory={true}
                    />
                  </div>
                </div>
                <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <InputField
                      control={control}
                      label="Salary From"
                      type="number"
                      name="salaryFrom"
                      {...register("salaryFrom", {
                        required: "Salary From is required",
                        validate: (value) => {
                          const to = getValues("salaryTo");
                          return (
                            !to ||
                            parseFloat(value) <= parseFloat(to) ||
                            "Salary From must be less than or equal to Salary To"
                          );
                        },
                      })}
                      errors={errors}
                      onChange={(value) => setValue("salaryFrom", value)}
                      isMandatory={true}
                    />
                  </div>
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <InputField
                      control={control}
                      label="Salary To"
                      type="number"
                      name="salaryTo"
                      {...register("salaryTo", {
                        required: "Salary To is required",
                        validate: (value) => {
                          const from = getValues("salaryFrom");
                          return (
                            !from ||
                            parseFloat(value) >= parseFloat(from) ||
                            "Salary To must be greater than or equal to Salary From"
                          );
                        },
                      })}
                      errors={errors}
                      onChange={(value) => setValue("salaryTo", value)}
                      isMandatory={true}
                    />
                  </div>
                </div>
                <div
                  className={
                    "flex xs:flex-col items-end w-full sm:gap-2 lg:gap-4"
                  }
                >
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
                    <InputField
                      control={control}
                      label="Number Of Positions"
                      type="number"
                      name="positions"
                      {...register("positions", {
                        required: "Positions is required",
                      })}
                      errors={errors}
                      onChange={(value) => setValue("positions", value)}
                      isMandatory={true}
                    />
                  </div>
                </div>
                <div className="flex justify-start items-start w-full lg:gap-x-5 flex-wrap xs:gap-2">
                  {options.map((option) => (
                    <div
                      className="flex justify-start flex-col items-start mt-[18px]"
                      key={option.id}
                    >
                      <div className="flex justify-start flex-wrap gap-x-3 gap-y-4 items-center w-full lg:pb-4">
                        <div className="flex justify-start items-center">
                          <input
                            type="checkbox"
                            id={option.id}
                            name={option.id}
                            className="custom-checkbox"
                            checked={
                              option.id === "active"
                                ? selectedOption.active === 1
                                : option.id === "inactive"
                                ? selectedOption.active === 0
                                : !!selectedOption[option.id]
                            }
                            onChange={(e) => handleSelectOptions(e, option.id)}
                          />
                          <label
                            htmlFor={option.id}
                            className="text-secondary font-onestRegular lg:text-sm ml-2 cursor-pointer"
                          >
                            {option.label}
                          </label>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="flex justify-center flex-col items-center pt-2.5 sm:pt-5 pb-5 sm:pb-10">
                <HoverButton
                  extraClasses={
                    "group xs:w-56 xs:h-10 sm:w-60 sm:h-12 lg:w-64 cursor-pointer bg-cover flex lg:h-12 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md"
                  }
                  BtnTitle={
                    loadingToapi ? (
                      <div className="flex justify-center items-center">
                        <div className="animate-spin rounded-full border-t-2 border-b-2 group-hover:border-primary border-secondary h-12 w-12 lg:w-10 lg:h-10  md:w-8 md:h-8 sm:w-10 sm:h-10 xs:w-8 xs:h-8"></div>
                      </div>
                    ) : (
                      "Create"
                    )
                  }
                  type={"submit"}
                  BtnTitleClasses={
                    "text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform group-hover:scale-110 group-hover:text-primary"
                  }
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateJob;
